import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const jenkins = defineConnector({
  identifier: "jenkins",
  name: "Jenkins",
  tagLine: "Open-source CI/CD server",
  keywords:
    "ci cd continuous integration delivery builds jobs pipelines hudson",
  logo,
  protocol: "http",
  tags: ["engineering"],
  auth: (app) =>
    basicAuth({
      username: app.config.username,
      password: app.secret.apiToken,
    }),
  steps: [
    {
      title: "Get your Jenkins API token",
      items: [
        {
          kind: "markdown",
          content:
            "In Jenkins, click your username in the top right, go to **Configure**, and under **API Token** click **Add new Token**.",
        },
      ],
    },
    {
      title: "Enter your Jenkins details",
      items: [
        {
          kind: "baseUrl",
          label: "Jenkins server URL",
          required: true,
          placeholder: "https://jenkins.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Jenkins server.",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/json`,
  },
});
